export const Hidden = (props) => {
    return <div style={{
        display: "none"
    }}>
        {props.children}
    </div>
}